import { Address } from '@ravago/shared/page-data/models/elements/address.model';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Table } from '@ravago/shared/radiance/components/table/components/Table/Table';
import { TableBody } from '@ravago/shared/radiance/components/table/components/TableBody/TableBody';
import { TableCell } from '@ravago/shared/radiance/components/table/components/TableCell/TableCell';
import { TableRow } from '@ravago/shared/radiance/components/table/components/TableRow/TableRow';
import { MultiLineText } from '@ravago/shared/radiance/components/typography/components/MultiLineText/MultiLineText';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

interface AddressProps {
   address: Address;
   timeframe?: string;
}

interface DeliveryAreaProps {
   country: string;
   city: string;
   postalCode: string;
   timeframe?: string;
}

type Props = AddressProps | DeliveryAreaProps;

export const RfqDeliveryInfo = ({ timeframe, ...props }: Props) => {
   const translate = useTranslations();

   return (
      <Box direction="column">
         <Table stroked="horizontal" tableLayout="fixed" hover={false}>
            <TableBody>
               <TableRow>
                  <TableCell>
                     <Typography component="b" variant="body-highlight" color="primary">
                        {translate('page-consumer.request-for-quotation.delivery-address')}
                     </Typography>
                  </TableCell>

                  <TableCell>
                     {/* HACK: Render the address lines multiline without injecting html */}
                     {'address' in props ? (
                        <MultiLineText text={props.address.htmlFormat} lineBreak="<br>" />
                     ) : (
                        <>
                           <Typography variant="body">
                              {props.postalCode} {props.city}
                           </Typography>
                           <Typography variant="body" component="p">
                              {props.country}
                           </Typography>
                        </>
                     )}
                  </TableCell>
               </TableRow>
               <TableRow>
                  <TableCell>
                     <Typography component="b" variant="body-highlight" color="primary">
                        {translate('page-consumer.request-for-quotation.delivery-timeframe')}
                     </Typography>
                  </TableCell>
                  <TableCell>{timeframe ?? ''}</TableCell>
               </TableRow>
            </TableBody>
         </Table>
      </Box>
   );
};
